import { combineReducers } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createApiActionCreators,
  createReducer,
  createActionType,
  REQUEST,
  SUCCESS,
  FAILURE,
} from '../../../common/utils/reduxHelpers';
import adminDashboardApi from '../api';

/**
 * ACTION TYPES
 */
export const FETCH_DASHBOARD_DATA = 'adminDashboard/FETCH_DASHBOARD_DATA';

/**
 * ACTIONS
 */
export const fetchReportDataActions = createApiActionCreators(FETCH_DASHBOARD_DATA);

/**
 * REDUCERS
 */
const initialState = {
  reportData: null,

};

const reportData = createReducer(initialState.reportData, {

  [FETCH_DASHBOARD_DATA]: {
    [SUCCESS]: (state, payload) => payload,
    [FAILURE]: state => null,
  }
});

export default combineReducers({
  reportData
});

/**
 * SELECTORS
 */
export const selectDashboardState = state => state.dashboard
export const selectReportData = state => selectDashboardState(state).reportData;



/**
 * SAGAS
 */
function* fetchReportData() {

  const resp = yield call(adminDashboardApi.fetchReportData);

  if (resp.ok) {
    yield put(fetchReportDataActions.success(resp.data));
  } else {
    yield put(fetchReportDataActions.failure(resp.error));
  }
}


export function* dashboardSaga() {
  yield takeLatest(createActionType(FETCH_DASHBOARD_DATA, REQUEST), fetchReportData);
}



// WEBPACK FOOTER //
// ./src/features/admin-dashboard/ducks/index.js